import StopOutlined from '@ant-design/icons/StopOutlined'
import { Form, Input } from 'antd'
import React, { useEffect, useState } from 'react'
import {
  CharCount,
  CounterHint,
  HeaderIcon,
  ModalHeader,
  ReasonField,
  RejectModal,
  SectionLabel,
  StepOption,
  StepOptionDesc,
  StepOptionTitle,
  StepOptions,
} from './PopupRejectDocumentStyled'

const { TextArea } = Input

const MAX_ROLLBACK = 2
const REASON_MAX = 2000

/**
 * Popup Từ chối / trả hồ sơ định hướng về Bước 1 hoặc Bước 2.
 */
const PopupRejectDocument = ({
  visible,
  onCancel,
  onOk,
  loading,
  /** currentStep UI (0-based): 1=Trưởng ĐV, 2=P.KTAT, 3=TP.KTAT, 4=Giám đốc */
  currentStep,
  /** Số lần đã trả về chỉnh sửa (sau lần unlock gần nhất) */
  rollbackCount = 0,
}) => {
  const [form] = Form.useForm()
  const [returnToStep, setReturnToStep] = useState(1)
  const [reasonLen, setReasonLen] = useState(0)

  const onlyCreator = currentStep === 1
  const remaining = Math.max(0, MAX_ROLLBACK - rollbackCount)
  const willLock = rollbackCount >= MAX_ROLLBACK

  useEffect(() => {
    if (visible) {
      setReturnToStep(1)
      setReasonLen(0)
      form.setFieldsValue({
        return_to_step: 1,
        reason: undefined,
      })
    }
  }, [visible, form])

  const selectStep = step => {
    setReturnToStep(step)
    form.setFieldsValue({ return_to_step: step })
  }

  const handleOk = () => {
    form.validateFields().then(values => {
      onOk({
        return_to_step: values.return_to_step,
        reason: (values.reason || '').trim(),
      })
    })
  }

  return (
    <RejectModal
      title={
        <ModalHeader>
          <HeaderIcon $danger={willLock}>
            <StopOutlined />
          </HeaderIcon>
          <span>Từ chối hồ sơ</span>
        </ModalHeader>
      }
      visible={visible}
      onCancel={onCancel}
      onOk={handleOk}
      confirmLoading={loading}
      okText={willLock ? 'Từ chối & khóa' : 'Xác nhận từ chối'}
      cancelText="Đóng"
      okButtonProps={{ danger: true }}
      destroyOnClose
      width={460}
      centered>
      <CounterHint $danger={willLock}>
        {willLock
          ? 'Lần thứ 3 — hệ thống sẽ khóa luồng trình ký'
          : `Còn ${remaining}/${MAX_ROLLBACK} lần trả về chỉnh sửa`}
      </CounterHint>

      <Form form={form} layout="vertical" requiredMark={false}>
        <Form.Item
          name="return_to_step"
          style={{ marginBottom: 0 }}
          rules={[{ required: true, message: 'Chọn bước trả về' }]}>
          <SectionLabel>Trả hồ sơ về</SectionLabel>
          <StepOptions $single={onlyCreator}>
            <StepOption
              type="button"
              $active={returnToStep === 1}
              onClick={() => selectStep(1)}>
              <StepOptionTitle>Bước 1</StepOptionTitle>
              <StepOptionDesc>Người lập</StepOptionDesc>
            </StepOption>
            {!onlyCreator && (
              <StepOption
                type="button"
                $active={returnToStep === 2}
                onClick={() => selectStep(2)}>
                <StepOptionTitle>Bước 2</StepOptionTitle>
                <StepOptionDesc>Trưởng đơn vị</StepOptionDesc>
              </StepOption>
            )}
          </StepOptions>
        </Form.Item>

        <ReasonField>
          <Form.Item
            name="reason"
            label={<SectionLabel as="span">Lý do từ chối</SectionLabel>}
            style={{ marginBottom: 0 }}
            rules={[
              { required: true, message: 'Nhập lý do từ chối' },
              { whitespace: true, message: 'Nhập lý do từ chối' },
            ]}>
            <TextArea
              rows={3}
              maxLength={REASON_MAX}
              placeholder="Nhập chi tiết lý do — sẽ ghi vào nhật ký xử lý"
              onChange={e => setReasonLen((e.target.value || '').length)}
            />
          </Form.Item>
          <CharCount>
            {reasonLen}/{REASON_MAX}
          </CharCount>
        </ReasonField>
      </Form>
    </RejectModal>
  )
}

export default PopupRejectDocument
export { MAX_ROLLBACK }
